import useSWR, { mutate } from "swr";
import { del, get, patch, post, put } from "./apiHandler";
interface UseApiOptions<T> {
  onSuccess?: (data: T) => void;
  revalidateOnFocus?: boolean;
  refreshInterval?: number;
  ids?: number[];
  // سایر گزینه‌های SWR را می‌توانید اضافه کنید
}

export const useApi = <T>(url: string | null, options?: UseApiOptions<T>) => {
  const fetcher = (url: string) => get(url);

  const {
    data,
    error,
    isLoading,
    mutate: refresh,
  } = useSWR<T>(url, fetcher, options);

  const create = async (data: unknown) => {
    await post(url || "", data);
    await mutate(url);
  };

  const update = async (data: unknown) => {
    await put(`${url}`, data);
    await mutate(url);
  };

  const remove = async (data: unknown) => {
    await del(`${url}`, data);
    await mutate(url);
  };

  const partialUpdate = async (data: unknown) => {
    await patch(`${url}`, data);
    await mutate(url);
  };

  const upload = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    await post(url || "", formData);
    await mutate(url);
  };

  return {
    data,
    error,
    isLoading,
    create,
    update,
    remove,
    partialUpdate,
    upload,
    refresh,
  };
};
